import { gql, useQuery } from "@apollo/client";
import { Psychoed } from "src/types/psychoed";

export const PsychoedQuery = gql`
  query PsychoedQuery($id: ID!) {
    psychoed(id: $id) {
      id
      name
      description
      visibility
      clinicId
      authorId
      thumbnail {
        id
        url
        preferredHeight
        preferredWidth
        svg
        altText
      }
      estimatedMinutes
      slides {
        id
        title
        subtitle
        headerImage {
          id
          url
          preferredHeight
          preferredWidth
          svg
          altText
        }
        blocks {
          id
          position
          type
          text
          image {
            id
            url
            preferredHeight
            preferredWidth
            svg
            altText
          }
        }
        hidden
        position
      }
      archived
      draft
    }
  }
`;

const AllPsychoedsQuery = gql`
  query AllPsychoeds {
    allPsychoeds {
      id
      name
      description
      thumbnail {
        id
        url
        preferredHeight
        preferredWidth
        svg
        altText
      }
      estimatedMinutes
      slides {
        id
        title
        subtitle
        headerImage {
          id
          url
          preferredHeight
          preferredWidth
          svg
          altText
        }
        blocks {
          id
          position
          type
          text
          image {
            id
            url
            preferredHeight
            preferredWidth
            svg
            altText
          }
        }
        hidden
        position
      }
      archived
      draft
    }
  }
`;

export const useAllPsychoeds = () => {
  const data = useQuery<{ allPsychoeds: Psychoed[] }>(AllPsychoedsQuery);

  return data;
};
